export const FETCH_PARTIESLIST_REQUEST = "FETCH_PARTIESLIST_REQUEST";
export const FETCH_PARTIESLIST_SUCCESS = "FETCH_PARTIESLIST_SUCCESS";
export const FETCH_PARTIESLIST_FAILURE = "FETCH_PARTIESLIST_FAILURE";
